<body>
    <div class="headerContratos">
        <div class="align-left search">
            <input type="text" [(ngModel)]="searchString" (keyup)="aplicarFiltro()" placeholder="Filter">
        </div>
        <h3 class="subtitulo">Contratos</h3>
        <div class="align-right">
            <button mat-button (click)=" editDialog(items)">
                <span class="material-icons">note_add</span> Cadastrar Transportador
            </button>

        </div>
    </div>
    <ul>
        <table>
            <thead>
                <tr class="header-row">
                    <td><label>ID</label></td>
                    <td><label>Transportador</label></td>
                    <td><label>Custo fixo</label></td>
                    <td><label>Custo variavel</label></td>
                    <td><label>Fluxo</label></td>
                    <td><label>Modalidade</label></td>
                    <td><label>Região</label></td>
                    <td><label>Tipo de veiculo</label></td>
                    <td><label>Validade</label></td>
                    <td><label>Ações</label></td>
                </tr>
            </thead>
            <tbody *ngIf="contracts">
                <tr *ngFor="let item of contracts">
                    <td>{{ item.ID }}</td>
                    <td>{{ item.carrier }}</td>
                    <td>{{ item.fixedCost | currency : 'BRL'}}</td>
                    <td>{{ item.variableCost | currency : 'BRL'}}</td>
                    <td>{{ item.flow}}</td>
                    <td>{{ item.modality}}</td>
                    <td>{{ item.region}}</td>
                    <td>{{ item.vehicleType}}</td>
                    <td>{{ item.validity}}</td>
                    <td class="action-buttons">
                        <button mat-icon-button color="primary" aria-label="Editar" (click)="editDialog(item)">
                            <span class="material-icons">edit</span>
                        </button>
                        <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button
                            color="warn" aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, queryContracts)">
                            <span class="material-icons">delete</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </ul>
</body>
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Cadastro de Contratos</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000">
                <tr>
                    <td>
                        <label class="modal-label">Transportador</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="carrier" [(ngModel)]="item.carrier" class="modal-input1"
                            (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.carrier == null || item.carrier == undefined || item.carrier == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label class="modal-label">Custo fixo</label>
                    </td>
                    <td>
                        <input type="text" name="fixedCost" [(ngModel)]="item.fixedCost" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Custo variavel</label>
                    </td>
                    <td>
                        <input type="text" name="variableCost" [(ngModel)]="item.variableCost" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Fluxo</label>
                    </td>
                    <td>
                        <!-- <input type="text" name="flow" [(ngModel)]="item.flow" class="modal-input1"> -->
                        <select name="flow" id="flow" [(ngModel)]="item.flow" class="modal-input1">
                            <option value="Import">Import</option>
                            <option value="Export">Export</option>
                            <option value="Empty Return">Empty Return</option>
                            <option value="MR Great SP">MR Great SP</option>
                            <option value="MR Sul">MR Sul</option>
                            <option value="Interplant">Interplant</option>
                            <option value="Latinet">Latinet</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label class="modal-label">Modalidade</label>
                    </td>
                    <td>
                        <select id="modality" name="modality" [(ngModel)]="item.modality" class="modal-input1">
                            <option value="FTL1">FTL 1</option>
                            <option value="FTL2">FTL 2</option>
                            <option value="LTL">LTL</option>
                        </select>
                    </td>
                    <td>
                        <label class="modal-label">Região</label>
                    </td>
                    <td class="flex1">
                        <input type="text" name="region" [(ngModel)]="item.region" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td>
                        <label class="modal-label">Tipo de veiculo</label>
                    </td>
                    <td class="flex1">
                        <!-- <input type="text" name="vehicleType" [(ngModel)]="item.vehicleType" class="modal-input1"> -->
                        <select id="vehicleType" name="vehicleType" [(ngModel)]="item.vehicleType" class="modal-select" (blur)="onFieldTouched()">
                            <option *ngFor="let vehicle of typesVehicles" [value]="vehicle">{{ vehicle }}</option>
                        </select>
                        <div *ngIf="campoTocado && (item.vehicleType == null || item.vehicleType == undefined || item.vehicleType == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                    <td>
                        <label class="modal-label">Validade*</label>
                    </td>
                    <td class="align-left">
                        <input type="date" name="validity [(ngModel)]="item.validity class="modal-input1"
                            (blur)="onFieldTouched()">
                        <div
                            *ngIf="campoTocado && (item.validity == null || item.validity == undefined || item.validity == '')">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                   
                </tr>
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>